export interface AccommodationType {
  id: number;
  typeName: string;
}

export enum AccommodationTypeIds {
  AUSTIN = 1,
  DALI,
  BALI,
  ANY,
}

export type AccommodationTypeName = keyof typeof AccommodationTypeIds;
